import dayjs from "dayjs"
import { useState } from "react"
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap"
import { toast } from "react-toastify"
import { ApiEndpoints, LinkEndpoint, reqGetDownloadFile, reqPostNew } from "../../../../../config/apiClient"
import NFSeModalEmissaoErro from "./ModalEmissaoErro"
import { useDispatch, useSelector } from "react-redux"
import { selecionarNotas } from "../notasServicoSlice"

export default function ModalEmitirNotasSelecionadas({ show, handleClose, notas }: iProps) {
    const [loading, setLoading] = useState<boolean>(false)
    const [notasAtualizadas, setNotasAtualizadas] = useState<boolean>(false)
    const [showModalErroEmissao, setShowModalErroEmissao] = useState<boolean>(false)
    const [modalErroEmissaoResponse, setModalErroEmissaoResponse] = useState<any>({})
    const notasSelecionadas: any[] = useSelector((state: any) => state.uiNotasServico.notas_selecionadas)
    const dispatch = useDispatch()

    async function emitirNotas() {
        if (!window.confirm("Tem certeza que deseja emitir?")) {
            return
        }
        setLoading(true)
        let notasAux = []
        for (let nota of notas) {
            const notaEmitida = await emitir(nota)
            notasAux.push(notaEmitida)
        }
        dispatch(selecionarNotas({ notas_selecionadas: notasAux }))
        setNotasAtualizadas(true)
        setLoading(false)
    }
    async function emitir(notaDados: any): Promise<any> {
        let nota = notaDados.nota
        if (nota.status === "Emitido" || nota.status === "Emitido (Cancelado)") {
            return {
                nota,
                emissao: {},
            }
        }

        let descriminacao = nota.servico_descriminacao
        let possuiInfoSemEditar = descriminacao.search("#obs#")
        if (possuiInfoSemEditar >= 0) {
            toast.warning("Há informações que precisam ser informadas na descrição da NF! #obs#", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            return {
                nota,
                emissao: {}
            }
        }
        let info_complementar = nota.servico_info_complementar === null ? "" : nota.servico_info_complementar
        let possuiInfoSemEditarInfo = info_complementar.search("#obs#")
        if (possuiInfoSemEditarInfo >= 0) {
            toast.warning("Há informações que precisam ser informadas na descrição complementar da NF! #obs#", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            return {
                nota,
                emissao: {}
            }
        }
        const empresa = notaDados.nota.id_empresa
        const aliquotaIss = await consultarISS(empresa, nota)
        if (empresa.nfs_situacao_simp_nac === 1) {
            if (!aliquotaIss.consulta_realizada) {
                toast.warning(`ERRO AO CONSULTAR ISS, VERIQUE COM O SUPORTE!`, {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                setLoading(false)
                return
            }

            const iss = aliquotaIss.aliquota
            if (iss !== null) {
                const issNota = Number(nota.ISS)
                if (issNota !== iss) {
                    toast.warning(`Atualize o ISS = ${String(iss)}!`, {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                    setLoading(false)
                    return
                }
            }
        }
        if (nota.ISS === "0.00") {
            if (!window.confirm("O ISS não foi informado, CONTINUAR?")) {
                setLoading(false)
                return
            }
        }
        const urlEmitir: LinkEndpoint = {
            endpoint: ApiEndpoints.apiNew + `/nfse/emitir/${nota.id}`,
            timeout: 10000,
        }
        const opcoesEmitir = {
            informar_iss: aliquotaIss.informar_iss,
            // informar_iss: true,
        }
        const api = await reqPostNew(urlEmitir, opcoesEmitir)
        if (api.status === 200) {
            nota = api.data.nota
            if (api.data.response.status_code === 201) {
                // await sleep(1000)
                // await formDownload("pdf", api.data.nota)
                let resultado: iResultado = {
                    nota: nota,
                    erro: null,
                    mensagem: "Emitido!"
                }
                return {
                    nota,
                    emissao: resultado
                }
            } else {
                let resultado: iResultado = {
                    nota: nota,
                    erro: JSON.stringify(api.data.response, null, 4),
                    mensagem: "Corrigir ERRO"
                }
                return {
                    nota,
                    emissao: resultado
                }
            }
        } else {
            let resultado: iResultado = {
                nota: nota,
                erro: null,
                mensagem: "Erro de conexão!"
            }
            return {
                nota,
                emissao: resultado
            }
        }
    }
    async function consultarISS(empresa: any, nota: any): Promise<any> {
        if (empresa.nfs_situacao_simp_nac === 3) {
            return {
                aliquota: Number(empresa.nfs_ISS),
                informar_iss: true,
                consulta_realizada: true,
            }
        }
        const dados = {
            "cod_cidade": nota.servico_cidade_cod,
            "cod_servico": nota.servico_cod,
            "data_competencia": nota.dps_data_competencia,
        }
        const api = await reqPostNew(ApiEndpoints.nfseConsultarISS, dados)
        let informar_iss = false
        if (api.status === 200) {
            const iss = api.data
            if (iss.response.status_code === 200) {
                const key: string = Object.keys(iss.response.data.aliquotas)[0]
                const aliquota = iss.response.data.aliquotas[key][0].Aliq
                return {
                    aliquota: Number(aliquota),
                    informar_iss: informar_iss,
                    consulta_realizada: api.status === 200,
                }
            } else {
                informar_iss = true
            }
        }
        return {
            aliquota: null,
            informar_iss: informar_iss,
            consulta_realizada: api.status === 200,
        }
    }

    if (notas.length === 0) {
        return (
            <div></div>
        )
    }

    return (
        <Modal
            show={show}
            onHide={() => { handleClose({ atualizar: notasAtualizadas }) }}
            backdrop="static"
            keyboard={false}
            size="xl"
            id="modal_nfse_emitir_selecionadas"
        >
            <Modal.Header closeButton>
                <Modal.Title>Emissao de NFS-e</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <NFSeModalEmissaoErro
                    show={showModalErroEmissao}
                    handleClose={() => { setShowModalErroEmissao(false); setModalErroEmissaoResponse({}) }}
                    errorData={modalErroEmissaoResponse}
                />
                <div className="div-row">
                    <Button variant="success" onClick={(event) => { emitirNotas() }} disabled={loading} style={{ marginRight: "10px" }} >Emitir todas as NFS-e</Button>
                    {loading && <Spinner></Spinner>}
                </div>
                <br></br>
                <div>
                    {
                        notasSelecionadas.map((notaDados: any, idx: number, arr: any[]) => {
                            const nota = notaDados.nota
                            const urlNota = `/nfse?id_empresa=${nota.id_empresa.id_empresa}&id_nota=${nota.id}`

                            return (
                                <div key={idx} style={{
                                    marginBottom: "10px",
                                    paddingBottom: "10px",
                                    backgroundColor: "#eeeeeeff",
                                    borderRadius: "5px",
                                    padding: "5px",
                                }}>
                                    <Row style={{ marginBottom: "5px" }}>
                                        <Col className="col-6">
                                            <p>Cliente: {nota.id_cliente.nome}</p>
                                            <p>Data competência: {dayjs(nota.dps_data_competencia).format("DD/MM/YYYY")}</p>
                                            <p>Status: <b>{nota.status}</b></p>
                                            <p><b><a href={urlNota} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>Visualizar</a></b></p>
                                        </Col>
                                        <Col className="col-6">
                                            <EmissaoNFResultado nota={notaDados} handleOpenErro={(erro: any) => { setShowModalErroEmissao(true); setModalErroEmissaoResponse(erro); }} />
                                        </Col>
                                    </Row>
                                    <Row style={{ marginBottom: "5px" }}>
                                        <Col className="col-2">VALOR <br></br>{nota.valor_servicos}</Col>
                                        <Col className="col-2">LIQUIDO <br></br>{nota.valor_liquido}</Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-2">IRRF <br></br>{nota.IRRF} <br></br> {nota.IRRF_V}</Col>
                                        <Col className="col-2">INSS <br></br>{nota.CP} <br></br> {nota.CP_V}</Col>
                                        <Col className="col-2">COFINS <br></br>{nota.COFINS} <br></br> {nota.COFINS_V}</Col>
                                        <Col className="col-2">CSLL <br></br>{nota.CSLL} <br></br> {nota.CSLL_V}</Col>
                                        <Col className="col-2">PIS <br></br>{nota.PIS} <br></br> {nota.PIS_V}</Col>
                                        <Col className="col-2">ISS <br></br>{nota.ISS} <br></br> {nota.ISS_V}</Col>
                                    </Row>
                                </div>
                            )
                        })
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { handleClose({ atualizar: notasAtualizadas }) }}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}
interface iProps {
    show: boolean
    handleClose: any
    notas: any[]
}

function EmissaoNFResultado({ nota, handleOpenErro }: iPropsEmissaoNFResultado) {
    const [download, setDownload] = useState<boolean>(false)
    let enviado = Object.values(nota.emissao).length === 0 ? false : true
    let resultado: iResultado | null = null
    if (enviado) {
        resultado = nota.emissao
    }
    if (!enviado) {
        return (
            <p></p>
        )
    }

    async function formDownload(filetype: "xml" | "pdf") {
        setDownload(true)
        const urlAux = filetype === "xml" ? "xmlsign" : "danfse"
        const chave = urlAux === "danfse" ? nota.id_chave : nota.id
        const urlNota: LinkEndpoint = {
            endpoint: ApiEndpoints.apiNew + `/nfse/${urlAux}/${chave}`,
            timeout: 10000,
        }
        let filename = `NFSe ${nota.nNFSe} - ${nota.cidade_descricao} - ${nota.valor_servicos} - ${nota.id_cliente.nome}.${filetype}`
        if (urlAux === "xmlsign") {
            filename = `DPS NFID-${nota.id} - ${nota.cidade_descricao} - ${nota.valor_servicos} - ${nota.id_cliente.nome}.${filetype}`
        }
        const api = await reqGetDownloadFile(urlNota, filename)
        if (api.status === 200) {
            toast.success('Download realizado!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        if (api.status !== 200) {
            toast.error('Erro Download!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        setDownload(false)
    }
    async function formDownloadXML() {
        setDownload(true)
        const urlNota: LinkEndpoint = {
            endpoint: ApiEndpoints.apiNew + `/nfse/xml/${nota.id_chave}`,
            timeout: 10000,
        }
        const filename = `NFSe ${nota.nNFSe} - ${nota.cidade_descricao} - ${nota.valor_servicos} - ${nota.id_cliente.nome}.xml`
        const api = await reqGetDownloadFile(urlNota, filename)
        if (api.status === 200) {
            toast.success('Download realizado!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        if (api.status !== 200) {
            toast.error('Erro Download!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        setDownload(false)
    }

    if (resultado?.mensagem === "Corrigir ERRO") {
        return (
            <p>Resultado: <b>{resultado?.mensagem}</b> <span style={{ color: "blue", cursor: "pointer" }} onClick={(event) => { handleOpenErro(resultado?.erro) }}>VISUALIZAR</span></p>
        )
    }

    if (resultado?.mensagem === "Erro de conexão!") {
        return (
            <p>Resultado: <b>{resultado?.mensagem}</b></p>
        )
    }

    if (resultado?.mensagem !== "Emitido!") {
        return (
            <p></p>
        )
    }

    return (
        <div>
            <p><b>{resultado?.mensagem}</b></p>
            <div className="div-row" style={{ marginTop: "5px" }}>
                <Button onClick={() => { formDownloadXML() }} variant='success' style={{ height: '50px', marginRight: '10px' }} className='div-row-space-between' disabled={download}><span className="material-symbols-outlined" >code_blocks</span></Button>
                <Button onClick={() => { formDownload("pdf") }} variant='success' style={{ height: '50px', marginRight: '10px' }} className='div-row-space-between' disabled={download}><span className="material-symbols-outlined">docs</span></Button>
            </div>
        </div>
    )
}
interface iPropsEmissaoNFResultado {
    nota: any
    handleOpenErro: any
}

interface iResultado {
    nota: any
    erro: any
    mensagem: string
}
